{
  "titles": {
    "add_sales_channel": "Add New Sales Channel",
    "update_sales_channel": "Edit Sales Channel Information",
    "locale": "Locale",
    "product_information": "Product information"
  },
  "settings": {
    "show_customer_reviews": "Customer reviews",
    "show_product_description": "Long description",
    "show_product_images": "Product images",
    "show_product_key_selling_points": "Key selling points",
    "show_product_videos": "Video",
    "show_technical_specification": "Technical specification"
  },
  "labels": {
    "name": "Sales channel name",
    "locale": "Locale",
    "country": "Country",
    "currency": "Currency",
    "languages": "Languages",
    "vat": "VAT"
  },
  "texts": {
    "choose_locale": "Choose the locale in which this sales channel will operate. This will determine the default language, currency and VAT.",
    "product_information": "Please select the types of end-user facing product information you want to include in the product details in this sales channel."
  },
  "buttons": {
    "create": "Save & Continue",
    "update": "Save Changes",
    "delete_sales_channel": "Delete Sales Channel",
    "cancel": "Cancel"
  },
  "errors": {
    "name_blank": "Name must not be blank",
    "countryId_empty": "Country must not be empty",
    "currency_empty": "Currency must not be empty",
    "localeIds_empty": "Languages must not be empty",
    "fetch": "Error occurred while fetching sales channel",
    "create_sales_channel": "Error occurred while creating sales channel",
    "update_sales_channel": "Error occurred while updating sales channel",
    "remove_sales_channel": "Error occurred while removing sales channel"
  },
  "delete_sales_channel_confirmation_dialog": {
    "title": "Remove sales channel",
    "content": "Are you sure you want to remove the sales channel? This sales channel will be completely deleted.",
    "buttons": {
      "cancel": "Cancel",
      "delete": "Delete"
    }
  }
}
